<template lang="pug">
.container.grid-xl.py-2.manual-page
  .columns
    .column.col-12
      router-link.btn.btn-link.btn-sm(:to="{ name: 'app.manuais' }")
        i.fa.fa-arrow-left.fa-fw
        |  Voltar aos manuais

      h4.h4 Análises — Minhas análises: Atendimento
      p.text-gray Manual do usuário · OS-m Admin v1.84+

      h5.h5 Visão geral
      p
        | Esta parte explica como
        strong  atender
        |  uma análise atribuída a você: concluir, solicitar reanálise ou reabrir a OS-m para o fiscal. As ações só aparecem quando a situação é
        strong  Aguardando
        | .

      .toast.toast-primary
        | As ações de atendimento exigem a permissão
        strong  Ordem serviços → Análise → Minhas análises → Concluir
        | .

      h5.h5 1. Abrir a análise
      ol
        li Em
          strong  Análises → Minhas análises
          | , abra a análise com
          strong  Exibir
          | .
        li Role até o rodapé do painel. Com situação
          strong  Aguardando
          | , você verá os botões
          strong  Concluir
          | ,
          strong  Reanálise
          |  e
          strong  Reabrir OS-m
          | .

      figure.manual-figure
        img(:src="imgAcoes" alt="Botões Concluir, Reanálise e Reabrir OS-m")

      h5.h5 2. Concluir
      figure.manual-figure
        img(:src="imgConcluir" alt="Modal Concluir análise")
      ol
        li Clique em
          strong  Concluir
          | .
        li No modal
          strong  Concluir análise
          | , informe o
          strong  Parecer
          |  (mínimo 10 caracteres).
        li Selecione o
          strong  resultado
          |  da análise (ex.: Liberado definitivo, Regular, Irregular).
        li Clique em
          strong  Concluir análise
          | .
      p
        | O processo
        strong  não é reversível
        | . Após salvar, a análise deixa de ficar aguardando.

      h5.h5 3. Reanálise
      ol
        li Clique em
          strong  Reanálise
          | .
        li Informe o
          strong  novo analista
          |  e o
          strong  parecer
          | .
        li Confirme. A OS-m é encaminhada para o analista escolhido (irreversível).

      h5.h5 4. Reabrir OS-m
      ol
        li Clique em
          strong  Reabrir OS-m
          | .
        li Informe o
          strong  parecer
          | .
        li Confirme. A OS-m volta para o fiscal (irreversível).

      .divider
      router-link.btn.btn-primary(:to="{ name: 'app.manuais' }")
        i.fa.fa-book.fa-fw
        |  Voltar à lista de manuais
</template>

<script>
export default {
  data() {
    return {
      imgAcoes: require("@/assets/manuais/10b-analises-atendimento-acoes.png"),
      imgConcluir: require("@/assets/manuais/10c-analises-atendimento-concluir.png"),
    }
  },
}
</script>

<style lang="stylus" scoped>
.manual-page
  h5
    margin-top 1.5rem

  .manual-figure
    margin 1rem 0
    img
      max-width 100%
      height auto
      border 1px solid #e7e9ed
      border-radius 4px

  .toast
    margin 1rem 0
</style>
